var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [
      _c(
        "a",
        { staticClass: "webim_button", attrs: { href: "#", rel: "webim" } },
        [
          _c("img", {
            attrs: {
              src: "https://onlinerby.webim.by/button.php",
              border: "0",
            },
          }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }